import { Line } from "@visx/shape";

import Typography from "ds/components/Typography";

import { MARKER_DASH, MARKER_LABEL_Y, MARKER_LINE_TOP_Y, MARKER_STROKE_WIDTH } from "./constants";
import styles from "./styles.module.css";

type ConcurrencyChartMarkerProps = {
  x: number;
  yMax: number;
  label: string;
  labelY?: number;
};

// A dated landmark on the plot: a dashed rule spanning its full height, named by
// a label riding the top margin. The markers are told apart by those labels, so
// they all share one line style. Every line starts below the label rows, so a label
// moved up a row is never cut by one.
const ConcurrencyChartMarker = ({
  x,
  yMax,
  label,
  labelY = MARKER_LABEL_Y,
}: ConcurrencyChartMarkerProps) => (
  <>
    <Line
      from={{ x, y: MARKER_LINE_TOP_Y }}
      to={{ x, y: yMax }}
      stroke="var(--semantic-color-border-divider)"
      strokeWidth={MARKER_STROKE_WIDTH}
      strokeDasharray={MARKER_DASH}
      pointerEvents="none"
    />
    <text x={x} y={labelY} textAnchor="middle" className={styles.markerLabel} aria-hidden>
      <Typography tag="tspan" variant="p-body4">
        {label}
      </Typography>
    </text>
  </>
);

ConcurrencyChartMarker.displayName = "UsageWorkers.ConcurrencyChart.Marker";

export default ConcurrencyChartMarker;
